import { router } from "../router";

export const navigate = (to: any, options?: { replace?: boolean }) =>
  router.navigate(to, options);

export const navigateAction = (to: any, options?: { replace?: boolean }) => {
  const action = () => router.navigate(to, options);
  (action as any).type = "ROUTER_NAVIGATE";
  (action as any).payload = {
    method: options?.replace ? "replace" : "push",
    args: [to]
  };
  return action;
};
